import { apiClient } from "./client";

export interface InHouseConference {
    id: number;
    code: string | null;
    name: string | null;
    facility: string | null;
    inHouseStartDate: string | null;
    publicStartDate: string | null;
    publicEndDate: string | null;
    moveOutDate: string | null;
}

export interface DashboardFunction {
    id: number;
    begin: string | null;
    end: string | null;
    name: string | null;
    room: string | null;
    conferenceCode: string | null;
    isSet: boolean;
    roomSet: number | null;
    actual: number | null;
}

export interface FunctionCountDay {
    date: string;
    count: number;
}

export interface RegistrationStats {
    totalIndividuals: number;
    activeRegistrations: number;
    outstandingBalance: number;
}

export interface Dashboard {
    inHouseConferences: InHouseConference[];
    todaysFunctions: DashboardFunction[];
    functionCountsFrom: string;
    functionCountsTo: string;
    functionCounts: FunctionCountDay[];
    registrationStats: RegistrationStats;
}

export interface CalendarFunction {
    id: number;
    date: string | null;
    begin: string | null;
    end: string | null;
    name: string | null;
    room: string | null;
    conferenceId: number | null;
    conferenceCode: string | null;
    conferenceName: string | null;
    isSet: boolean;
    roomSet: number | null;
}

export async function getDashboard(from?: string, months?: number): Promise<Dashboard> {
    const response = await apiClient.get<Dashboard>("/dashboard", { params: { from, months } });
    return response.data;
}

export async function getCalendarFunctions(from: string, to: string): Promise<CalendarFunction[]> {
    const response = await apiClient.get<CalendarFunction[]>("/calendar", { params: { from, to } });
    return response.data;
}
